import React, { useContext } from "react";

import { css } from "@emotion/react";
import { getTextColor } from "@intelligems/ig-utils";

import { DiscountProgressBarContext } from "../context";

export const MessageRow = ({ message }: { message: string | undefined }) => {
  const { theme } = useContext(DiscountProgressBarContext);

  const messageClass = css`
    font-weight: bold;
    font-family: inherit;
    color: ${getTextColor(
      getComputedStyle(document.documentElement).getPropertyValue(
        theme.container.backgroundColorKey
      )
    )};
    text-align: center;
    width: 100%;
  `;
  return (
    <div className={"ig-dp-message"} css={messageClass}>
      <span dangerouslySetInnerHTML={{ __html: message || "" }} />
    </div>
  );
};
